export class SetStandalone {
  public static readonly type = '[UI] SetStandalone';
  constructor(public readonly standalone: boolean) {}
}
